import React, { useState, useEffect} from 'react';
import BannerInner from '../components/BannerInner';
import 'swiper/css';
import 'swiper/css/pagination';
import { BsEye, BsRocketTakeoff} from "react-icons/bs";
import CommonHelmet from '../components/CommonHelmet';
import axios from 'axios';

const Videos = () => {
    const title='Real Estate Consultant in Lucknow | Best Real Estate Company';
    const description='Urbanaid Infratech is the leading Property Consultants in Lucknow. We are a top class real estate builders in Lucknow. Visit urbanaidinfratech.com to check upcoming projects.';
    const canonical='/about';

    const [videoData, setVideoData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
        try {
            const res = await axios.get("/api/fetchvideos"); // Adjust port if needed
            const fetchedData = res.data; // Assuming data is an array
            setVideoData(fetchedData);
        } catch (err) {
            console.error("Error fetching data:", err);
        }
        };
        fetchData();
    }, []);

    return (
        <>
            <CommonHelmet title={title} canonical={canonical} description={description} />
            <BannerInner title={'Videos'} />
            <section className='aboutus flex py-8'>
                <div className='container mx-auto'>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
                    {videoData.map((video, idx) => (                        
                        <div key={idx} className='specs flex flex-col border border-gray-200 border-solid border-t-8 border-t-orange-500 text-gray-600 text-left relative items-baseline rounded-md'>
                            <div className='flex flex-row w-full' dangerouslySetInnerHTML={{ __html: video.embedcode }} />
                            <div className='flex flex-row w-full justify-between items-center px-3 py-2'>
                                <div className='text-base font-semibold text-gray-900 py-1'>{video.videotitle}</div>
                                <div className='flex flex-row space-x-2 items-center text-xs text-gray-400'>
                                    <span>
                                        {video.publishdate ? new Date(video.publishdate).toLocaleDateString('en-GB') : ''}
                                    </span></div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Videos;
